import { useContext } from 'react'
import { useArrayShuffle } from '../../hooks'
import GameContext from './GameContext'
import Data from '../../data.json'
import { CardType, initialCard } from './types'

type ClearGameStateFunction = () => void

export default (): ClearGameStateFunction => {
  const {
    setIconList,
    setIconFoundList,
    setIsPaused,
    setFirstSelectedCard,
    setSecondSelectedCard,
    difficulty,
    onStopTimer,
  } = useContext(GameContext)

  const onShuffleArray = useArrayShuffle<CardType>()

  const onClearGameState = (): void => {
    setIconFoundList([])
    setIsPaused(true)
    setFirstSelectedCard(initialCard)
    setSecondSelectedCard(initialCard)
    onStopTimer()

    const shuffledArray = onShuffleArray(Data.cards)
    let correctLengthArray = shuffledArray.slice(0, difficulty / 2)
    const correctLengthArray2 = correctLengthArray.map((card) => ({
      ...card,
      src: card.src2,
      caption: card.caption2,
    }))
    correctLengthArray = correctLengthArray.concat(correctLengthArray2)
    const correctLengthShuffledArray = onShuffleArray(correctLengthArray)
    setIconList(correctLengthShuffledArray)
  }

  return onClearGameState
}
